import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 2560.000000 2560.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,2560.000000) scale(0.100000,-0.100000)">

<path d="M8370 17244 c-19 -2 -80 -13 -135 -23 -55 -11 -171 -25 -257 -31
-127 -9 -170 -16 -220 -36 -35 -14 -100 -34 -146 -44 -49 -11 -99 -29 -121
-44 -20 -14 -42 -26 -49 -26 -41 0 -117 -26 -148 -50 -20 -16 -53 -32 -73 -36
-45 -8 -81 -26 -105 -53 -11 -12 -27 -21 -36 -21 -9 0 -32 -11 -51 -25 -19
-13 -59 -38 -90 -54 -31 -17 -59 -37 -63 -46 -3 -8 -26 -24 -50 -35 -24 -10
-48 -25 -53 -33 -4 -8 -28 -27 -53 -42 -44 -27 -72 -50 -151 -127 -22 -21 -43
-38 -49 -38 -15 0 -106 -93 -114 -115 -3 -12 -20 -29 -36 -38 -17 -10 -37 -31
-45 -46 -7 -15 -25 -35 -38 -44 -13 -8 -34 -36 -45 -60 -12 -25 -33 -53 -47
-64 -16 -11 -30 -33 -34 -53 -5 -25 -15 -39 -35 -48 -15 -8 -34 -29 -41 -46
-8 -18 -21 -39 -30 -46 -19 -16 -55 -83 -55 -103 0 -7 -11 -24 -25 -37 -14
-13 -34 -52 -45 -86 -10 -34 -30 -73 -43 -86 -16 -16 -29 -46 -37 -84 -8 -38
-22 -71 -40 -91 -26 -30 -31 -46 -45 -152 -4 -24 -17 -60 -31 -81 -24 -36 -33
-73 -53 -225 -5 -38 -20 -97 -33 -130 l-23 -60 -3 -2195 c-2 -1848 0 -2199 11
-2214 9 -13 33 -22 68 -26 30 -4 336 -7 680 -6 703 2 670 -2 682 73 4 21 6
977 7 2124 l0 2087 29 62 c16 34 32 85 36 113 11 88 16 107 39 135 13 15 31
54 40 87 10 34 30 73 46 90 15 17 31 41 35 55 4 14 27 48 51 75 74 85 114 129
135 150 11 11 37 36 57 56 20 21 55 46 78 57 23 12 48 32 57 45 10 15 32 28
60 35 24 6 52 21 63 33 27 30 47 39 110 49 34 6 66 19 85 34 16 14 47 27 72
30 23 3 89 13 147 23 138 22 317 22 460 0 63 -9 134 -20 157 -23 24 -3 52 -15
67 -29 16 -15 49 -29 87 -36 39 -8 71 -21 88 -37 29 -27 80 -52 109 -52 10 0
24 -11 30 -25 6 -13 25 -31 43 -41 39 -20 242 -224 275 -276 14 -21 31 -38 39
-38 9 0 20 -17 27 -46 7 -25 28 -64 47 -86 21 -25 37 -56 43 -86 5 -27 19 -57
34 -73 23 -24 28 -42 39 -136 7 -59 18 -128 25 -153 32 -114 33 -198 37 -2208
l3 -2032 31 -19 c29 -18 62 -18 683 -16 674 3 673 3 719 43 16 14 17 126 17
2091 0 1334 4 2115 10 2186 9 90 16 120 39 165 16 30 35 85 41 121 10 55 17
70 41 88 16 12 29 30 29 41 0 11 16 37 35 59 19 21 41 54 49 72 8 19 24 43 36
54 12 11 28 34 35 52 9 20 23 35 38 39 15 3 30 18 38 36 7 18 24 34 41 40 16
6 34 22 39 35 6 15 24 31 49 40 22 9 42 24 45 34 4 10 27 25 58 35 29 9 66 30
83 46 21 19 52 34 94 44 34 8 75 25 91 38 28 24 49 29 159 41 30 3 106 15 168
27 l113 20 137 -21 c75 -11 175 -25 221 -31 61 -7 95 -17 122 -34 20 -14 63
-32 95 -41 33 -10 73 -30 89 -45 17 -15 55 -39 85 -54 107 -53 145 -76 152
-96 4 -11 22 -27 40 -36 19 -8 41 -29 50 -45 25 -43 78 -41 120 4 38 41 67
103 68 144 0 21 10 44 30 66 17 19 34 55 40 83 7 31 22 59 41 78 16 15 34 47
41 70 6 22 24 53 39 69 16 16 32 49 39 77 7 30 21 57 35 68 13 10 30 34 38 53
8 19 31 54 51 78 20 23 39 53 42 66 3 12 19 32 35 44 16 12 29 30 29 40 0 19
24 44 53 54 9 4 17 13 17 22 0 8 18 34 39 58 51 55 64 120 31 155 -11 12 -24
22 -29 22 -4 0 -26 18 -48 39 -25 25 -53 42 -77 46 -25 5 -41 16 -53 36 -10
16 -29 31 -46 35 -16 3 -40 19 -55 35 -15 17 -46 35 -74 44 -27 8 -63 26 -79
40 -17 13 -54 32 -84 40 -29 9 -59 23 -66 31 -19 23 -43 33 -99 44 -28 5 -70
23 -93 40 -35 24 -57 31 -134 40 -90 10 -143 25 -143 41 0 15 -69 29 -205 39
-77 6 -169 18 -205 27 -108 26 -321 28 -475 4 -71 -11 -193 -25 -269 -31 -122
-9 -147 -13 -200 -39 -38 -18 -92 -34 -141 -41 -43 -5 -88 -17 -100 -25 -11
-8 -30 -22 -42 -31 -12 -9 -50 -18 -83 -21 -53 -5 -66 -11 -94 -39 -18 -19
-39 -34 -47 -34 -36 0 -92 -24 -121 -50 -18 -17 -41 -30 -51 -30 -27 0 -79
-29 -100 -56 -10 -13 -27 -24 -38 -24 -10 0 -36 -15 -56 -33 -21 -18 -52 -39
-69 -46 -17 -7 -46 -28 -65 -47 -18 -19 -39 -34 -46 -34 -7 0 -24 -17 -37 -39
-14 -22 -36 -41 -50 -45 -14 -3 -32 -19 -40 -35 -10 -18 -26 -30 -44 -34 -17
-4 -33 -16 -40 -31 -6 -14 -24 -32 -39 -40 -16 -8 -35 -26 -42 -40 -13 -23
-56 -46 -87 -46 -6 0 -34 23 -61 51 -26 29 -59 61 -72 73 -13 11 -36 33 -50
47 -57 56 -161 139 -175 139 -9 0 -33 18 -55 40 -22 22 -46 40 -55 40 -8 0
-25 13 -37 30 -13 17 -42 37 -68 47 -25 9 -58 29 -72 44 -15 15 -45 33 -67 39
-23 6 -55 22 -72 36 -17 14 -51 32 -76 40 -25 7 -59 25 -75 38 -16 14 -55 30
-86 37 -32 7 -71 22 -88 34 -18 13 -71 31 -132 44 -56 12 -126 33 -155 46 -44
20 -80 26 -213 35 -88 6 -198 19 -245 30 -87 19 -228 31 -290 24z"/>
<path d="M17248 14581 l-33 -29 -3 -594 c-2 -432 1 -600 9 -621 42 -102 184
-83 209 28 11 45 14 1104 4 1154 -18 87 -120 121 -186 62z"/>
<path d="M16941 14377 c-13 -6 -34 -25 -45 -40 -21 -28 -21 -39 -24 -498 -2
-407 -1 -474 13 -502 38 -82 149 -90 195 -15 19 32 20 51 20 508 0 453 -1 476
-19 504 -35 52 -90 69 -140 43z"/>
<path d="M16630 14163 c-36 -10 -63 -29 -76 -55 -11 -22 -14 -98 -14 -397 l0
-371 29 -32 c26 -29 35 -33 81 -33 46 0 55 4 81 33 l29 32 0 371 c0 374 -2
392 -37 427 -16 16 -71 31 -93 25z"/>
<path d="M16258 13924 c-54 -29 -58 -50 -58 -319 0 -271 4 -291 60 -320 52
-27 109 -14 147 35 9 11 12 88 12 285 1 241 -1 272 -17 291 -36 45 -93 56
-144 28z"/>
<path d="M15943 13713 c-12 -2 -34 -18 -48 -34 -24 -30 -25 -34 -25 -186 l0
-155 35 -35 c33 -33 39 -35 81 -30 32 3 55 13 73 31 25 26 26 31 29 164 2 81
-1 151 -7 172 -17 55 -76 86 -138 73z"/>
<path d="M13819 11863 c-15 -2 -35 -13 -45 -24 -16 -18 -17 -23 -4 -52 8 -18
14 -59 13 -92 0 -33 -2 -329 -3 -657 -2 -592 -2 -598 19 -632 12 -18 34 -39
49 -45 21 -9 242 -11 843 -9 766 3 817 4 842 21 41 27 45 47 13 71 -15 12 -46
38 -68 59 -23 20 -42 37 -43 37 -39 0 -126 27 -145 45 -14 13 -43 31 -65 41
-22 9 -53 27 -68 40 -16 13 -41 27 -55 30 -53 11 -81 26 -88 46 -3 11 -28 30
-57 43 -29 12 -61 33 -72 45 -11 12 -34 28 -51 35 -18 7 -37 23 -43 34 -7 11
-26 28 -44 37 -17 10 -43 29 -58 43 -14 14 -41 37 -59 51 -19 14 -63 53 -99
87 -36 34 -74 63 -83 63 -10 0 -29 18 -43 40 -13 21 -33 43 -43 49 -10 5 -24
21 -31 34 -7 14 -24 30 -37 36 -13 5 -30 26 -38 45 -8 19 -44 65 -81 103 -37
37 -78 85 -92 106 -13 21 -31 41 -39 44 -8 3 -24 23 -34 44 -11 21 -28 44 -38
51 -9 7 -26 32 -36 55 -10 23 -27 51 -38 63 -18 20 -27 21 -79 13z"/>
<path d="M6819 9730 c-90 -16 -183 -76 -227 -149 -103 -167 -39 -388 138 -470
100 -47 250 -39 374 20 l46 21 0 154 0 154 -130 0 -131 0 3 -72 3 -73 53 -3
c50 -3 52 -4 52 -33 0 -25 -6 -33 -35 -45 -182 -76 -336 149 -205 299 67 76
162 84 254 22 20 -14 38 -25 40 -25 6 0 86 106 86 113 0 11 -72 53 -120 70
-57 20 -142 27 -201 17z"/>
<path d="M7478 9730 c-104 -18 -200 -90 -248 -185 -21 -42 -25 -64 -25 -135 0
-72 4 -94 28 -145 53 -113 150 -176 285 -183 89 -5 142 5 235 46 l57 25 0 153
0 154 -130 0 -131 0 3 -72 3 -73 53 -3 c50 -3 52 -4 52 -33 0 -25 -6 -33 -37
-46 -54 -22 -132 -13 -176 20 -67 51 -95 155 -63 230 34 76 115 124 190 111
43 -7 110 -37 121 -54 3 -5 10 -10 14 -10 15 0 93 109 86 120 -20 33 -202 95
-260 89 -5 -1 -31 -5 -57 -9z"/>
<path d="M8600 9726 c-92 -26 -173 -96 -212 -181 -26 -58 -31 -173 -10 -243
21 -68 88 -142 167 -182 63 -32 75 -35 159 -35 83 0 97 3 158 33 73 36 124 87
160 161 32 65 32 195 0 266 -51 113 -164 184 -301 191 -44 2 -95 -2 -121 -10z
m180 -146 c136 -70 127 -291 -15 -345 -84 -32 -168 2 -210 86 -30 58 -32 115
-6 172 23 50 44 70 91 91 48 21 94 20 140 -4z"/>
<path d="M5732 9413 l3 -318 72 -3 73 -3 2 198 3 198 82 -167 82 -168 55 0
c31 0 56 4 56 9 0 4 35 80 78 167 l77 159 3 -197 2 -198 70 0 69 0 3 298 c2
163 2 307 0 320 -3 21 -8 22 -91 22 l-88 0 -89 -184 c-48 -101 -91 -183 -95
-181 -3 3 -46 85 -94 185 l-89 180 -93 0 -93 0 2 -317z"/>
<path d="M7890 9410 l0 -320 220 0 221 0 -3 68 -3 67 -132 3 -133 3 0 249 0
250 -85 0 -85 0 0 -320z"/>
<path d="M9130 9409 l0 -320 208 3 c191 3 210 5 252 26 120 60 133 229 22 293
l-39 23 37 27 c69 50 77 138 19 203 -49 56 -95 66 -311 66 l-188 0 0 -321z
m352 174 c24 -21 23 -58 -2 -83 -17 -17 -33 -20 -100 -20 l-80 0 0 60 0 60 82
0 c62 0 86 -4 100 -17z m-20 -233 c61 -17 77 -73 32 -109 -22 -17 -41 -21
-110 -21 l-84 0 0 70 0 70 63 0 c34 0 79 -5 99 -10z"/>
<path d="M9871 9507 c-52 -122 -112 -262 -133 -310 -21 -48 -38 -92 -38 -97 0
-6 37 -10 83 -10 l83 0 19 55 18 55 141 0 141 0 20 -52 21 -53 87 -3 c48 -1
87 -1 87 1 0 4 -44 109 -212 515 l-51 122 -86 0 -86 0 -94 -223z m223 -67 c20
-52 36 -98 36 -102 0 -5 -38 -8 -85 -8 -47 0 -85 2 -85 5 0 19 85 214 90 208
4 -4 24 -51 44 -103z"/>
<path d="M10460 9410 l0 -320 220 0 220 0 0 70 0 70 -135 0 -135 0 0 250 0
250 -85 0 -85 0 0 -320z"/>
<path d="M10970 9411 l0 -321 169 0 c138 0 181 4 230 19 154 48 242 196 212
358 -15 84 -39 130 -92 177 -80 73 -110 81 -326 84 l-193 4 0 -321z m374 155
c83 -63 98 -188 34 -282 -30 -44 -82 -64 -168 -64 l-70 0 0 191 0 192 84 -5
c73 -4 89 -8 120 -32z"/>
<path d="M11836 9722 c-4 -7 -209 -490 -263 -619 -4 -10 16 -13 80 -13 l84 0
20 53 20 52 140 3 140 3 23 -56 22 -55 84 0 c46 0 84 4 84 9 0 9 -58 151 -145
356 -19 44 -51 123 -72 175 l-38 95 -87 3 c-47 1 -89 -1 -92 -6z m128 -275
c20 -51 36 -98 36 -105 0 -8 -24 -12 -80 -12 -57 0 -80 4 -80 12 0 20 73 198
81 198 4 0 23 -42 43 -93z"/>
<path d="M12210 9660 l0 -70 95 0 95 0 0 -250 0 -250 85 0 85 0 0 250 0 250
95 0 95 0 0 70 0 70 -275 0 -275 0 0 -70z"/>
<path d="M12888 9542 c-43 -103 -102 -245 -133 -315 -30 -71 -55 -130 -55
-133 0 -2 38 -4 84 -4 l83 0 20 53 20 52 140 3 140 3 20 -53 20 -53 87 -3 c47
-1 86 1 86 5 0 4 -13 40 -29 78 -16 39 -68 165 -115 280 -48 116 -94 225 -102
243 l-15 32 -87 0 -87 0 -77 -188z m206 -99 c20 -51 36 -97 36 -103 0 -10
-152 -15 -162 -5 -7 8 76 214 84 207 4 -4 23 -48 42 -99z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
